function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeolocations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.12,
    height: 20.001,
    viewBox: "0 0 12.12 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6660",
    d: "M191.847 27.668a.478.478 0 0 0 .371-.177c.232-.286 5.69-7.082 5.69-12.471a6.06 6.06 0 0 0-12.12 0c0 5.389 5.457 12.184 5.689 12.471a.477.477 0 0 0 .37.177zm0-15.092a2.511 2.511 0 1 1-2.537 2.51 2.527 2.527 0 0 1 2.537-2.509z",
    transform: "translate(-185.787 -9.011)",
    style: {
      fill: "#aeaeae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6661",
    d: "M208.175 525.14h-10.31a.477.477 0 0 0 0 .954h10.311a.477.477 0 0 0 0-.954z",
    transform: "translate(-196.96 -506.093)",
    style: {
      fill: "#aeaeae"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeolocations);
export default __webpack_public_path__ + "static/media/geolocations.95ffa624f217d241c192910af5a4cf36.svg";
export { ForwardRef as ReactComponent };